import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen bg-primary">
      <Header />
      <main className="animate-fade-in">{children}</main>
      <Footer />
    </div>
  );
}
